// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","371":"component---src-pages-tos-js","745":"component---src-pages-privacy-js"}[chunkId] + "-" + {"125":"539f3c1a79ed7da0c8ca","293":"cdf64ba4246a2bca22c0","371":"ab03ed09fac7e9f3419a","745":"a891e5009dacd74ff6de"}[chunkId] + ".js";
};